import React from 'react'
import ScreenHeader, { ScreenHeaderProps } from '../../kyc/ScreenHeader'
import './ScreenLayout.css'

export interface ScreenLayoutProps extends ScreenHeaderProps {
  children?: React.ReactNode
  layoutContentClassName?: string
  layoutContentStyle?: React.CSSProperties
}

export const ScreenLayout = (props: ScreenLayoutProps) => {
  const { children, layoutContentClassName, layoutContentStyle, ...rest } =
    props
  return (
    <div className="layout" style={{ height: '100%', flex: 1 }}>
      <ScreenHeader {...rest} />
      <div
        className={`layout-content ${layoutContentClassName || ''}`}
        style={layoutContentStyle}
      >
        {children}
      </div>
    </div>
  )
}

export default ScreenLayout
